export const getLeaseDuration = (metaObject: any) => {
  let leaseDuration = null;
  if (metaObject?.lease_duration > 0 && metaObject.lease_duration_unit) {
    leaseDuration = `${metaObject.lease_duration} ${metaObject.lease_duration_unit}`;
  }
  return leaseDuration;
};

export const getLeaseDurationRange = (metaObject: any) => {
  let leaseDuration = "";

  if (metaObject?.min_lease_duration > 0) {
    leaseDuration += `${metaObject.min_lease_duration} `;
  }

  if (metaObject?.max_lease_duration > 0) {
    leaseDuration += `${leaseDuration && "-"} ${metaObject.max_lease_duration} `;
  }

  if (leaseDuration !== "") {
    leaseDuration += metaObject.lease_duration_unit;
  }

  return leaseDuration;
};

export const getLeaseDurationPostConfirmation = (stayDuration: any) => {
  let leaseDuration = null;
  if (stayDuration?.duration > 1) {
    leaseDuration = `${stayDuration?.duration} ${stayDuration?.duration_unit}s`;
  } else {
    leaseDuration = `${stayDuration?.duration} ${stayDuration?.duration_unit}`;
  }
  return leaseDuration;
};
